import get from 'lodash/get';
import has from 'lodash/has';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';

import { NewPlpTypes } from 'lib/apis/services/NewPlpListiing';
import { DescribedLocationV2 } from 'lib/apis/services/PlpListing/type';
import useScrollY from 'lib/hooks/useScroll';
import { usePlpStore } from '../../DataStore';
import { semanticFilterBox } from '../../constant';

export const useFilterBoxWrapper = () => {
  const scrollPositionChanged = useScrollY();
  const { filterData, describeLocations } = usePlpStore();

  const defaultValues = semanticFilterBox.reduce<typeof filterData>(
    (result, item) => {
      if (filterData[item.fieldName]) {
        if (item.type !== 'RANGE') {
          result[item.fieldName] = filterData[item.fieldName];
          if (item.type === 'INTEGER') {
            result[`${item.fieldName}Exact`] = get(
              filterData,
              `${item.fieldName}Exact`,
              false
            );
          }
        } else
          result[item.fieldName] = {
            min: null,
            max: null,
            ...(filterData[item.fieldName] as NewPlpTypes.RangeValue),
          };
      } else {
        switch (item.type) {
          case 'INTEGER':
            result[item.fieldName] = get(filterData, item.fieldName, null);
            result[`${item.fieldName}Exact`] =
              result[item.fieldName] === null
                ? false
                : get(filterData, `${item.fieldName}Exact`, false);
            break;
          case 'RANGE':
            result[item.fieldName] = {
              min: null,
              max: null,
            };
            break;

          default:
            result[item.fieldName] = [];
            if (item.fieldName === 'propertyTypeIds') {
              if (!has(filterData, 'propertyTypeIds')) {
                result[item.fieldName] = (
                  item.values as NewPlpTypes.ArrayNumberFilterValueType[]
                ).map((val) => val.id);
              }
            }

            if (item.fieldName === 'landuseType') {
              if (!has(filterData, 'landuseType')) {
                result[item.fieldName] = (
                  item.values as NewPlpTypes.ArrayNumberFilterValueType[]
                ).map((val) => val.id);
              }
            }
            break;
        }
      }
      if (describeLocations) {
        result.location = describeLocations as DescribedLocationV2[];
      }

      return result;
    },
    {}
  );

  const methods = useForm<typeof filterData>({
    defaultValues,
  });

  useEffect(() => {
    methods.reset(defaultValues);
  }, []);

  return {
    scrollPositionChanged,
    methods,
  };
};
